require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2005-04-06-the-long-road-of-development.json") })
        }
      }, "path---articles-2005-04-06-the-long-road-of-development");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2005-04-06-the-long-road-of-development!./.cache/json/articles-2005-04-06-the-long-road-of-development.json
// module id = 392
// module chunks = 231608221292675